import React, { Component } from 'react';
import Confetti from 'react-dom-confetti';
import { connect } from 'react-redux';

import {
  activateFeatureTour,
  completeAndUpdateTour,
  startSelfExploreTour,
} from 'actions/feature-tour';
import {
  HELP_RECORD_VIDEO,
  SHARE_WITH_LOOM_TEAM_COMPLETE,
  SHARE_WITH_LOOM_TEAM_OPT_IN,
} from 'constants/feature-tour';
import { EXPERIMENT_SHARE_WITH_LOOM_TEAM } from 'constants/featureFlag';
import { getFeatureFlagCreator } from 'creators/featureFlag';
import * as analytics from 'utilities/analytics';
import { showShareLoomForm } from 'utilities/share-loom-exp';

import firstVideoImgSrc from 'img/onboarding/first-video.svg';

import { VIDEO_OWNER_PAGE_ONBOARDING_INTRO } from '../../../constants/events';

import Button from 'components/ui-components/button';
import Modal from 'components/ui-components/modal';

import styles from './styles.module.less';

const confettiConfig = {
  angle: 90,
  spread: 90,
  startVelocity: 67,
  elementCount: 150,
  decay: 0.9,
};

class FirstVideoModal extends Component {
  state = {
    showConfetti: false,
  };

  componentDidMount() {
    this.props.getFeatureFlag(EXPERIMENT_SHARE_WITH_LOOM_TEAM);

    if (this.props.show) {
      analytics.track(VIDEO_OWNER_PAGE_ONBOARDING_INTRO);

      setTimeout(() => {
        this.setState({
          showConfetti: true,
        });
      }, 2000);
    }
  }

  onSelfExplore = () => {
    this.props.onRecordedFirstVideo();
    this.props.startSelfExploreTour();

    analytics.track('Video Owner Page Onboarding Skip', {
      exit_step: 'first video recorded',
    });
  };

  onTourStart = () => {
    this.props.onRecordedFirstVideo();
    this.props.activateFeatureTour();

    analytics.track('Video Owner Page Onboarding Start');
  };

  onSendToLoom = () => {
    this.props.onRecordedFirstVideo();

    showShareLoomForm();
  };

  render() {
    const { show, wantsToShareWithLoomTeam } = this.props;

    return (
      <Modal
        show={show}
        showClose={true}
        onDismiss={this.props.onRecordedFirstVideo}
        className={styles.firstVideoModal}
      >
        {wantsToShareWithLoomTeam && (
          <div className={styles.container}>
            <img className={styles.videoImg} src={firstVideoImgSrc} />
            <span className={styles.heading}>Now send your Loom to us!</span>
            <p className={styles.descriptionExp}>
              Your Loom URL is automatically copied to your clipboard. Continue
              below to send to the Loom team - we watch every video shared with
              us!
            </p>
            <div className={styles.buttonsContainer}>
              <Button
                outerClass={styles.actionButton}
                buttonType="rp-secondary-3"
                capitalize={false}
                value="Not right now"
                onClicked={this.onSelfExplore}
              />
              <Button
                outerClass={styles.actionButton}
                buttonType="rp-primary-3"
                value="Send to Loom"
                onClicked={this.onSendToLoom}
              />
            </div>
            <Confetti
              active={this.state.showConfetti}
              config={confettiConfig}
            />
          </div>
        )}
        {!wantsToShareWithLoomTeam && (
          <div className={styles.container}>
            <img className={styles.videoImg} src={firstVideoImgSrc} />
            <span className={styles.heading}>Your first Loom video!</span>
            <p className={styles.description}>
              Congrats on your first video! Now see Loom’s editing suite and
              sharing options.
            </p>
            <div className={styles.buttonsContainer}>
              <Button
                outerClass={styles.actionButton}
                buttonType="rp-secondary-3"
                capitalize={false}
                value="I’ll explore on my own"
                onClicked={this.onSelfExplore}
              />
              <Button
                outerClass={styles.actionButton}
                buttonType="rp-primary-3"
                value="Let's Go"
                onClicked={this.onTourStart}
              />
            </div>
            <Confetti
              active={this.state.showConfetti}
              config={confettiConfig}
            />
          </div>
        )}
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const { user, share_video, feature_flags: featureFlags } = state;

  const userLoggedInAndLoaded = user.is_logged_in_checked && user.is_logged_in;

  const userOwnsVideo = share_video.current_user_is_owner;

  const shareFirstVideoFlag =
    featureFlags[EXPERIMENT_SHARE_WITH_LOOM_TEAM] || {};
  const isInShareFirstVidExp = shareFirstVideoFlag.value === 'show';

  const hasSeenFirstVideoOnboarding =
    user.current.onboarding[HELP_RECORD_VIDEO];

  const wantsToShareWithLoomTeam =
    isInShareFirstVidExp &&
    user.current.onboarding[SHARE_WITH_LOOM_TEAM_OPT_IN];

  const show =
    userLoggedInAndLoaded && !hasSeenFirstVideoOnboarding && userOwnsVideo;

  return {
    show,
    wantsToShareWithLoomTeam,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onRecordedFirstVideo: () =>
      dispatch(completeAndUpdateTour(HELP_RECORD_VIDEO)),
    activateFeatureTour: () => dispatch(activateFeatureTour()),
    startSelfExploreTour: () => dispatch(startSelfExploreTour()),
    getFeatureFlag: featureFlag => dispatch(getFeatureFlagCreator(featureFlag)),
    setShareWithLoomComplete: () =>
      dispatch(completeAndUpdateTour(SHARE_WITH_LOOM_TEAM_COMPLETE)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FirstVideoModal);
